// What the Boards v2 developer tools say this build reads (the Dev chip's
// "In this build", on a board and on the boards list; local development
// builds only, IL-046): a sandbox's Firebase emulator, or production.
export const BOARDS_DEV_BACKEND: string = process.env.VUE_APP_FIREBASE_EMULATOR_HOST
	? 'the Firebase emulator at ' + process.env.VUE_APP_FIREBASE_EMULATOR_HOST + ' (project ' + process.env.VUE_APP_FIREBASE_PROJECT_ID + ')'
	: 'production data (Firebase project image-ai-cb35d)';
